// setShouldDisplayUnmuteHint.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set should display the unmute hint (one-off livestream hint on this device).
 * @kind action
 * @param {boolean} shouldDisplayUnmuteHint - If true, the unmute hint will be shown; otherwise, it will be hidden.
 * @return {Promise} Action promise.
 */
const setShouldDisplayUnmuteHint =
  ({ shouldDisplayUnmuteHint }) =>
  async dispatch =>
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          shouldDisplayUnmuteHint,
        },
      },
    });
export default setShouldDisplayUnmuteHint;
